export default "__VITE_ASSET__BZHFFDw5__"